import { compose } from 'lodash/fp';
import api from '../../../../api';
import PageHeader from '../../../components/PageHeader';
import PageStatic from '../../../components/PageStatic';
import PageTitle from '../../../components/PageTitle';
import { withAppContext } from '../../../hoc/withAppContext';
import { withPageData } from '../../../hoc/withPageData';
import AdminOverview from './presenter';
import { countAdminErrors, groupLinksByCategory } from './service';

function AdminOverviewPage({ adminLinks, promotionLinks, appContext }) {
    const title = 'Settings';
    return (
        <PageStatic>
            <PageTitle title={title} />
            <PageHeader title={title} />
            <AdminOverview
                categories={groupLinksByCategory([...adminLinks, ...promotionLinks])}
                errorCount={countAdminErrors(adminLinks)}
                currentUser={appContext.user}
            />
        </PageStatic>
    );
}

export default compose(
    withPageData({
        resolve: {
            adminLinks: () => api.admin.getSettingsLinks(),
            promotionLinks: () => api.admin.getPromotionsLinks(),
        },
    }),
    withAppContext
)(AdminOverviewPage);
